import * as React from "react";
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { SearchListItemLink } from "./SearchListItemLink";

export const CustomerListItem = (props: any) => {
  const { data, onClick } = props;
  const { content } = data;

  if (!content) {
    return null;
  }

  const fullname = `${content.first_name} ${content.last_name}`;

  return (
    <ListItem
      component={SearchListItemLink}
      data={data}
      onClick={onClick}
      alignItems="flex-start"
      data-testid="user"
    >
      <ListItemAvatar
        sx={{
          marginX: 1,
        }}
      >
        <Avatar>
          <PersonIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography
            color="textPrimary"
            sx={{
              textTransform: "capitalize",
            }}
          >
            {fullname}
          </Typography>
        }
        secondary={content.email}
      />
    </ListItem>
  );
};
